// @flow
import initializers from '../dependencies/initializers'
import axios from 'axios'

const REGISTER_HOST = 'https://app-v2.astrnt.co/api'

export function usersCheckEmailApi(email: string) {
	return axios({
		url: REGISTER_HOST+'/users/check-email',
		timeout: 20000,
		method: 'post',
		responseType: 'json',
		// headers: {'X-Requested-With': 'XMLHttpRequest'},
		data: {
			email
		}
	})
}

export async function usersSaveDataApi(data: Object) {

		return await axios({
			url: REGISTER_HOST+'/users',
			timeout: 20000,
			method: 'post',
			responseType: 'json',
			// headers: {'X-Requested-With': 'XMLHttpRequest'},
			data
		})
		.then(response => ({ response }))
		.catch(error => ({ error }))


}

export function usersResendVerificationEmailApi(email: string) {
	return axios({
		url: REGISTER_HOST+'/auth/resend-verification',
		timeout: 20000,
		method: 'post',
		responseType: 'json',
		data: {
			email: email
		}
	})
}

// M1-684: quick sign-up from the ASTRNT Recommends candidate search page.
// Backend endpoint TBC with API team - creates a pending account from
// company_name/email/mobile_number/job_title, deferring fullname/password to
// the existing email-verification flow.
// M1-703: for source "try_question", also sends skill/question_text/answer_text/result
// (plus question_code, the interview log-correlation id) so the post-signup landing can
// show the already-submitted question and its scoring result without re-asking the user
// to redo the exercise. skill/question_text/answer_text are all-or-nothing on the
// backend; result is optional but needed for the recap screen to render.
export async function usersQuickSignUpApi(data: Object) {

		return await axios({
			url: initializers.recommends_host+'/api/users/quick-register',
			timeout: 20000,
			method: 'post',
			responseType: 'json',
			data
		})
		.then(response => ({ response }))
		.catch(error => ({ error }))

}
